module.exports = __webpack_public_path__ + "img/swift-sport-2022.1b413747.svg";